Monitoring.Dashboard ||= {}

#TODO this class needs refactor, duplicated code in Monitoring.Views.SocialContents.Filters.TagsFilterView

class Monitoring.Dashboard.SocialContentTagsView extends Backbone.View
  template:             JST['backbone/templates/monitoring/social_contents/tags_editor/social_content_tags']
  appliedTagsTemplate:  JST['backbone/templates/monitoring/social_contents/tags_editor/applied']
  possibleTagsTemplate: JST['backbone/templates/monitoring/social_contents/tags_editor/possible']
  controlsTemplate:     JST['backbone/templates/monitoring/social_contents/tags_editor/controls']

  className: 'bottom social-content-tags'

  events:
    'change select.tags': 'onAdd'
    'click button.tag': 'onClickTagButton'
    'click .done': 'onSave'
    'click .cancel': 'onCancel'
    'click .show-hierarchy': 'showHierarchy'
    'click .show-more-tags': 'onShowMoreTags'

  initialize: (@options = {}) ->
    @possibleTags = @options.possibleTags
    @initiallySelectedTagCodes = @options.selectedTagCodes
    @currentlySelectedTagCodes = @options.selectedTagCodes
    @suggestedTags = @options.suggestedTags
    @deselectedTags = []
    @readOnly = @options.readOnly || false
    @mode = @options.mode || 'explore'
    # flags
    @toggleableControls = @options.toggleableControls if @options.toggleableControls?
    @editionMode = !@toggleableControls
    @withIconAndLabel = @options.withIconAndLabel || false
    @groupsInsteadOfTags = @options.groupsInsteadOfTags || false
    @showAddNewTags = @options.showAddNewTags || false

  # public

  showTagsEditor: (toggle=true) =>
    if toggle && @editionIsExpanded()
      @onCancel()
      return
    @editionMode = true
    @updateTagsEditorVisibility()
    @updateControlsVisibility()
    @forceExpandShowMoreTags()
    @_toggleAddNewTags()

  hasTags: ->
    @currentlySelectedAndVisibleTagCodes().length > 0

  editionIsExpanded: =>
    @possibleTagsContainer().is(':visible')

  render: =>
    @$el.html(@template(@))
    @$el.removeClass('disabled')
    @appliedTagsContainer().html(@appliedTagsTemplate(@))
    @controlsContainer().html(@controlsTemplate(@))
    @toggleShowMoreTags()
    setTimeout(@hideShowMoreButton, 10)
    @updateTagsEditorVisibility()
    @updateControlsVisibility()
    @_toggleAddNewTags()
    @$el

  # private

  appliedTagsContainer: ->
    @$el.find('.tags-editor-applied')

  possibleTagsContainer: ->
    @$el.find('.tags-editor-possible')

  controlsContainer: ->
    @$el.find('.tags-editor-controls')

  updateTagsEditorVisibility: =>
    @initializeChosen() if @editionMode
    @possibleTagsContainer().toggle(@editionMode)
    unless @groupsInsteadOfTags
      @possibleTagsContainer().css('margin-right', '0px')
    @controlsContainer().toggle(@editionMode)
    if (@mode == 'explore' || @mode == 'review') && !@groupsInsteadOfTags
      @$el.find('.tags-editor-controls, .tag-controllers').css('float', 'none')
    @trigger('changed:editorVisibility', @editionIsExpanded())

  onShowMoreTags: =>
    @toggleShowMoreTags()
    false

  toggleShowMoreTags: ->
    @appliedTagsContainer().toggleClass('minimized')

  forceExpandShowMoreTags: ->
    @appliedTagsContainer().removeClass('minimized')

  hideShowMoreButton: =>
    return unless @appliedTagsContainer().hasClass('minimized')
    container = @appliedTagsContainer().find('.applied_tags')[0]
    hasOverflow = container.scrollHeight > container.clientHeight || container.scrollWidth > container.clientWidth
    if !hasOverflow
      @forceExpandShowMoreTags()
      @appliedTagsContainer().find('.show-more-tags').addClass('hidden')

  initializeChosen: ->
    @possibleTagsContainer().html(@possibleTagsTemplate(@))
    select = @$el.find('select.tags')
    select.chosen(width: 'auto', search_contains: true)
    chosenDrop = @$el.find('.chosen-drop').hide()
    select.on('chosen:showing_dropdown', ->
      chosenDrop.show()
    )
    select.on('chosen:hiding_dropdown', ->
      chosenDrop.hide()
    )

  mustHideHierarchy: ->
    not Keepcon.currentAccount.hierarchy?

  onClickTagButton: (evt) =>
    @_keepCustomerSessionAlive()
    return if @readOnly
    target = $(evt.currentTarget)
    clientCode = target.data('code')
    tag = _.find(@possibleTags, (t) -> t.code == clientCode)
    if target.hasClass('active')
      @currentlySelectedTagCodes = _.without(@currentlySelectedTagCodes, clientCode)
      @deselectedTags = @deselectedTags.concat(tag)
    else
      @currentlySelectedTagCodes = @currentlySelectedTagCodes.concat(clientCode)
      @deselectedTags = _.without(@deselectedTags, tag)
    @showTagsEditor(false)

  updateControlsVisibility: () ->
    if @mustShowControls()
      @showDone()
      @showCancel()
    else if @toggleableControls && @editionMode
      @hideDone()
      @showCancel()
    else
      @hideDone()
      @hideCancel()

  mustShowControls: ->
    @mode != 'review' && @mode != 'filter' && @hasChanges()

  hasChanges: ->
    !_.isEqual(_.sortBy(@currentlySelectedTagCodes), _.sortBy(@initiallySelectedTagCodes))

  showDone: ->
    if @mode == 'review'
      @$el.find('.done').removeClass('hidden')
    else
      @$el.find('.done').prop('disabled', false)

  showCancel: ->
    @$el.find('.cancel').removeClass('hidden')
    @appliedTagsContainer().find('.show-more-tags').addClass('hidden')

  hideDone: ->
    if @mode == 'review'
      @$el.find('.done').addClass('hidden')
    else
      @$el.find('.done').prop('disabled', true)

  hideCancel: ->
    @$el.find('.cancel').addClass('hidden')
    @appliedTagsContainer().find('.show-more-tags').removeClass('hidden')

  onAdd: (evt) =>
    @_keepCustomerSessionAlive()
    target = $(evt.currentTarget)
    clientCode = target.val()
    @currentlySelectedTagCodes = _.uniq(@currentlySelectedTagCodes.concat(clientCode))
    target.find('option:selected').remove()
    target.trigger('chosen:updated')
    @appliedTagsContainer().html(@appliedTagsTemplate(@))
    @updateControlsVisibility()

  onCancel: =>
    @currentlySelectedTagCodes = @initiallySelectedTagCodes
    @deselectedTags = []
    @editionMode = false if @toggleableControls
    @render()
    false

  onSave: =>
    @_keepCustomerSessionAlive()
    @$el.addClass('disabled')
    @trigger('changed:tags', @currentlySelectedTagCodes)
    false

  showHierarchy: ->
    @_keepCustomerSessionAlive()
    unless @codeToDescription
      @codeToDescription = {}
      _.each(@possibleTags, (tag) => @codeToDescription[tag.code] = tag.description)
    @tagsHierarchyView.remove() if @tagsHierarchyView
    @tagsHierarchyView = new Monitoring.Views.Dashboards.TagsHierarchyModalView({
      firstLevelNodes: Keepcon.currentAccount.hierarchy.root.children
      currentTags: @currentlySelectedTagCodes # The counters are not shown in the tree
      translator: @codeToDescription
    })
    @listenTo(@tagsHierarchyView, 'selected:tags', @onChangeTagsFromHierarchy)
    @$el.append(@tagsHierarchyView.render().el)
    @tagsHierarchyView.showModal()

  onChangeTagsFromHierarchy: (newTagsCodes) ->
    @tagsHierarchyView.closeModal()
    appliedHiddenTags = _.filter(@possibleTags, (tag) => tag.hidden and _.contains(@currentlySelectedTagCodes, tag.code))
    @currentlySelectedTagCodes = _.union(newTagsCodes, _.pluck(appliedHiddenTags, 'code'))
    setTimeout =>
      @render()
    , 500

  currentlySelectedTags: ->
    ret = _.map @currentlySelectedTagCodes, (tagCode) =>
      _.find @possibleTags, (tag) => tag.code == tagCode
    _.compact ret

  currentlySelectedAndVisibleTagCodes: ->
    _.filter @currentlySelectedTags(), (tag) => !tag.hidden

  # --- Methods duplicated in social_content.js.coffee ---
  mainTags: ->
    _.filter(@possibleTags, (tag) => @isMainTag(tag))

  isMainTag: (tag) ->
    @hasTag(tag) or @isHotTag(tag) or @isSuggestedTag(tag)

  hasTag: (tag) ->
    @arrayHasTag(@currentlySelectedTagCodes, tag)

  isHotTag: (tag) ->
    @canEditTags() and tag.hot_tag

  isSuggestedTag: (tag) ->
    @arrayHasTag(@suggestedTags, tag)

  tagSentimentFor: (tag) ->
    definedTag = Keepcon.tags.find (definedTag) -> definedTag.code == tag.code
    definedTag?.sentiment || 'neutral'

  arrayHasTag: (array, tag) ->
    tag = tag || {}
    description = tag.description || ''
    code = tag.code || ''
    _.intersection(array, [tag, tag.description, tag.code]).length > 0

  negativeTags: ->
    _.filter(@possibleTags, (tag) => tag.implies_rejection == true && !@isMainTag(tag))

  neutralTags: ->
    _.filter(@possibleTags, (tag) => !tag.implies_rejection && !@isMainTag(tag))

  unappliedTags: ->
    @neutralTags().concat(@negativeTags()) # does not include suggested tags

  canEditTags: ->
    @editTags || (@mode == 'review')

  _keepCustomerSessionAlive:->
    Backbone.trigger 'customerSession:keepAlive'

  _toggleAddNewTags: ->
    @$el.find('.add-new-tags').addClass('hidden') if @editionMode || !@showAddNewTags
